import { useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";

const BundleBanner = ({ product }) => {
  const { addItem } = useCart();
  const navigate = useNavigate();

  if (!product) return null;

  const buyNow = () => {
    addItem(product);
    navigate("/cart");
  };

  return (
    <div
      data-testid="bundle-banner"
      className="fade-up mt-8 bg-[#F0DDD9] border border-[#E4C4BD] rounded-2xl px-8 sm:px-12 py-12 sm:py-14 flex flex-col md:flex-row md:items-center md:justify-between gap-10"
    >
      {/* Left: label, title, description */}
      <div className="md:max-w-2xl">
        <p className="text-[11px] uppercase tracking-[0.24em] text-[#B08F50] font-semibold mb-4">
          Best Value &middot; Save $9
        </p>
        <h3 className="font-serif-display text-3xl sm:text-4xl text-[#4A3F35] leading-tight">
          The Soft Life Reset Bundle
        </h3>
        <p className="mt-4 text-[15px] leading-relaxed text-[#6b5d50]">
          {product.description}
        </p>
      </div>

      {/* Right: price + button */}
      <div className="shrink-0 md:text-right">
        <p className="font-serif-display text-5xl text-[#C6A769] leading-none">
          <span className="align-super text-2xl">$</span>{Math.round(product.price)}
        </p>
        <p className="text-[11px] uppercase tracking-[0.2em] text-[#B08F50] font-semibold mt-2">
          Both Products
        </p>
        <button
          onClick={buyNow}
          data-testid="bundle-buy-button"
          className="mt-6 inline-block bg-[#C6A769] text-[#4A3F35] px-10 py-4 rounded-sm text-sm font-semibold uppercase tracking-[0.18em] transition-all duration-300 hover:bg-[#B08F50] hover:scale-[1.02]"
        >
          Buy the Bundle
        </button>
      </div>
    </div>
  );
};

export default BundleBanner;
